import Handlebars from "handlebars";

Handlebars.registerHelper("deviceMedia", function (deviceType) {
  if (deviceType === "large") {
    return "(min-width: 1440px)";
  } else if (deviceType === "desktop") {
    return "(min-width: 1024px)";
  } else if (deviceType === "tablet") {
    return "(min-width: 480px)";
  } else if (deviceType === "phone") {
    return "(max-width: 479px)";
  }
});

Handlebars.registerHelper("descendingDevicePrecedence", function (variants) {
  return sortDeviceMedia(variants, true);
});

Handlebars.registerHelper("ascendingDevicePrecedence", function (variants) {
  return sortDeviceMedia(variants, false);
});

function sortDeviceMedia(variants, reverse) {
  if (!variants) {
    return;
  }

  var newObject = {};
  var devicePrecedence = ["large", "desktop", "tablet", "phone"];

  if (reverse) {
    devicePrecedence = devicePrecedence.reverse();
  }

  devicePrecedence.forEach(function (key) {
    var variant = variants[key];

    if (variant) {
      newObject[key] = variant;
    }
  });

  return newObject;
}
